'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.FieldTrashcan = /*#__PURE__*/function () {
  function FieldTrashcan(board) {
    (0, _classCallCheck2["default"])(this, FieldTrashcan);
    if (board) {
      this.setBoard(board);
    }
    this.dragBlock = null;
    this.dragBlockObserver = null;
    this.isOver = false;
    if (Entry.windowResized) {
      Entry.windowResized.attach(this, this.setPosition);
    }
  }
  return (0, _createClass2["default"])(FieldTrashcan, [{
    key: "_generateView",
    value: function _generateView() {
      this.svgGroup = this.board.svg.elem('g');
      this.renderStart();
      this._addControl();
    }
  }, {
    key: "renderStart",
    value: function renderStart() {
      var path = "".concat(Entry.mediaFilePath, "delete_");
      this.svgGroup.elem('image', {
        href: "".concat(path, "body.svg"),
        y: 19,
        width: 61,
        height: 70
      });
      this.trashcanTop = this.svgGroup.elem('image', {
        href: "".concat(path, "cover.svg"),
        width: 60,
        height: 27
      });
    }
  }, {
    key: "_addControl",
    value: function _addControl() {
      $(this.svgGroup).bind('mousedown', function (e) {
        if (Entry.Utils.isRightButton(e)) {
          e.stopPropagation();
          $('#entryWorkspaceBoard').css('background', 'white');
        }
      });
    }
  }, {
    key: "updateDragBlock",
    value: function updateDragBlock() {
      var block = this.board.dragBlock;
      var observer = this.dragBlockObserver;
      if (observer) {
        observer.destroy();
        this.dragBlockObserver = null;
      }
      if (block) {
        if (block instanceof Entry.Comment) {
          this.dragBlockObserver = block.observe(this, 'checkBlock', ['moveX', 'moveY']);
        } else {
          this.dragBlockObserver = block.observe(this, 'checkBlock', ['x', 'y']);
        }
      } else {
        if (this.isOver && this.dragBlock) {
          if (this.dragBlock instanceof Entry.BlockView) {
            var prevBlock = this.dragBlock.block.getPrevBlock();
            if (!prevBlock) {
              var _script$changeEvent;
              var script = this.dragBlock.block.getCode();
              Entry["do"]('destroyThread', this.dragBlock.block.thread, 'trashcan').isPass(true, true);
              Entry.Utils.playSound('entryDelete');
              script === null || script === void 0 || (_script$changeEvent = script.changeEvent) === null || _script$changeEvent === void 0 || _script$changeEvent.notify();
            }
          } else if (this.dragBlock instanceof Entry.Comment) {
            Entry["do"]('removeComment', this.dragBlock).isPass(true, true);
          }
        }
        this.tAnimation(false);
      }
      this.dragBlock = block;
    }
  }, {
    key: "checkBlock",
    value: function checkBlock() {
      var dragBlock = this.dragBlock;
      if (!dragBlock || dragBlock.block && !dragBlock.block.isDeletable()) {
        return;
      }
      var boardOffset = this.board.offset();
      var position = this.getPosition();
      var trashcanX = position.x + boardOffset.left;
      var trashcanY = position.y + boardOffset.top;
      var mouseX;
      var mouseY;
      var instance = dragBlock.dragInstance;
      if (instance) {
        mouseX = instance.offsetX;
        mouseY = instance.offsetY;
      }
      var isOver = mouseX >= trashcanX && mouseY >= trashcanY;
      this.tAnimation(isOver);
    }
  }, {
    key: "align",
    value: function align() {
      var position = this.getPosition();
      var transform = "translate(".concat(position.x, ",").concat(position.y, ")");
      this.svgGroup.attr({
        transform: transform
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      if (!this.board) {
        return;
      }
      var svgDom = this.board.svgDom;
      this._x = svgDom.width() - 83.5;
      this._y = svgDom.height() - 110;
      this.align();
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        x: this._x,
        y: this._y
      };
    }
  }, {
    key: "tAnimation",
    value: function tAnimation(isOver) {
      if (isOver === this.isOver) {
        return;
      }
      isOver = isOver === undefined ? true : isOver;
      var trashTop = this.trashcanTop;
      if (isOver) {
        $(trashTop).attr('transform', 'translate(20, -25) rotate(30)');
        // $(trashTop).attr('class', 'trashcanOpen');
      } else {
        $(trashTop).attr('transform', 'translate(0, 0) rotate(0)');
        // $(trashTop).attr('class', 'trashcanClose');
      }
      this.isOver = isOver;
    }
  }, {
    key: "setBoard",
    value: function setBoard(board) {
      if (this._dragBlockObserver) {
        this._dragBlockObserver.destroy();
      }
      this.board = board;
      if (!this.svgGroup) {
        this._generateView();
      }

      //control z-index
      var svg = board.svg;
      var firstChild = svg.firstChild;
      if (firstChild) {
        svg.insertBefore(this.svgGroup, firstChild);
      } else {
        svg.appendChild(this.svgGroup);
      }
      this._dragBlockObserver = board.observe(this, 'updateDragBlock', ['dragBlock']);
      this.svgGroup.attr({
        filter: "url(#entryTrashcanFilter_".concat(board.suffix, ")")
      });
      this.setPosition();
    }
  }]);
}();